import { render, staticRenderFns } from "./ScoreDetailForm.vue?vue&type=template&id=1a3b52bf&scoped=true"
import script from "./ScoreDetailForm.vue?vue&type=script&lang=js"
export * from "./ScoreDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ScoreDetailForm.vue?vue&type=style&index=0&id=1a3b52bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b52bf",
  null
  
)

export default component.exports